import mergeDeepRight from 'ramda/src/mergeDeepRight'
import { InformationsDetailPlan } from '@/types/plans'
import { PlanFromCMS } from './fetchPlansDetailsFromCMS'

export function mergePlanDetails(
  planFromAPI: InformationsDetailPlan,
  planFromCMS: PlanFromCMS
) {
  return mergeDeepRight(planFromAPI, planFromCMS)
}
